<!-- =========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
========================================================================================== -->

<template>
  <div id="page-user-list">
    <iframe src="https://gtbrdd.typeform.com/to/gNOoQ6" width="100%" height="700px" style="border:0px">

    </iframe>
  </div>
</template>
<script>
  import I18nFrData from '../../../i18n/i18n-fr-Data'
  export default {
    components: {I18nFrData}
  }
</script>
